<template>
  <div>
    <div v-if="current_event && current_event.event_id">
      <v-chip label>
        {{ mark_type_mapped[current_event.mark_type] || (current_event.marked_laiton ? "Merkattu laiton" : "Ei merkin tyyppiä") }}
      </v-chip>
      <!-- <div>
        <v-switch v-model="event_data.run.maximal_run" label="Lento + täysi juoksu (T)"></v-switch>
      </div> -->
      <div v-if="!event_data.run.run_id">
        <div style="width: 250px; margin: 0 auto;" v-for="(btn, i) in Object.keys( mapped_btns )" :key="btn">
          <v-btn
            class="justify-space-between mt-1"
            :color="event_data.run.run_video_times[btn] ? 'primary' : ''"
            :class="{ 'selected-time-button': selected_run_time_key === btn }"
            block
            small
            @click="handleBtnClick(btn)"
          >
            <span>{{ mapped_btns[btn] }}</span>
            <span class="grey--text">{{ i + 1 }}</span>
            <span class="ml-3" v-if="event_data.run.run_video_times[btn]">{{ secondsToPrettyTimer(event_data.run.run_video_times[btn] - event_data.run.run_first_data_point_video_time) }}</span>
          </v-btn>
        </div>
        <div class="mt-3" style="width: 250px; margin: 0 auto;">
          <div class="text-caption grey--text">
            Valittu aika: {{ selectedRunTimeLabel }}
          </div>
          <div class="d-flex justify-space-between mt-1">
            <v-btn x-small outlined @click="jumpPlayerTime(-0.02)">Z -0.02</v-btn>
            <v-btn x-small outlined @click="jumpPlayerTime(0.02)">X +0.02</v-btn>
          </div>
          <div class="d-flex justify-space-between mt-1">
            <v-btn x-small outlined @click="jumpPlayerTime(-0.1)">↑Z -0.1</v-btn>
            <v-btn x-small outlined @click="jumpPlayerTime(0.1)">↑X +0.1</v-btn>
          </div>
          <div class="d-flex justify-space-between mt-1">
            <v-btn x-small outlined @click="jumpPlayerTime(-1)">Ctrl+Z -1</v-btn>
            <v-btn x-small outlined @click="jumpPlayerTime(1)">Ctrl+X +1</v-btn>
          </div>
        </div>
        <div class="mt-3 flex align-center" style="width: 80%;">
          <span class="font-weight-bold">
            Etäisyys pesästä
          </span>
          <v-chip color="primary">
            <span v-if="event_data.run.runner_distance_from_base">
              {{ event_data.run.runner_distance_from_base.toFixed(1) }} m
            </span>
            <span v-else>
              x m
            </span>
          </v-chip>
          <v-btn fab text x-small @click="adjustRunnerDistance(-0.1)" :disabled="!event_data.run.runner_distance_from_base"><v-icon>mdi-minus</v-icon></v-btn>
          <v-btn fab text x-small @click="adjustRunnerDistance(0.1)"><v-icon>mdi-plus</v-icon></v-btn>
          <v-btn fab text x-small @click="event_data.run.runner_distance_from_base = null"><v-icon>mdi-close</v-icon></v-btn>
        </div>
      </div>
      <div v-else>
        <v-card class="pa-2" flat>
          <div class="mb-2">
            <div>Etäisyys: {{ event_data.run.runner_distance_from_base ? `${event_data.run.runner_distance_from_base.toFixed(1)}m` : '-' }}</div>
            <div>Lähtö: {{ event_data.run.run_times.lahto ? `${event_data.run.run_times.lahto.toFixed(3)}s` : '-' }}</div>
            <div>Aika: {{ event_data.run.total_run_time ? `${event_data.run.total_run_time}s` : '-' }}</div>
          </div>
        </v-card>
        <v-btn :loading="deleting_time" @click="deleteTime(event_data.run.run_id)" small color="error">
          Poista aika
          <v-icon class="ml-2" small>mdi-delete-outline</v-icon>
        </v-btn>
      </div>
      <div class="d-flex justify-center mt-6">
        <EventArrows :disabled="saveDisabled" @save="save"></EventArrows>
      </div>
      <v-divider class="mt-5 mb-5"></v-divider>
      <span style="color: grey;">
        Älä välitä tästä: <br>
        {{ event_data.run }}
      </span>
    </div>
    <div v-else>
      Valitse event
    </div>
  </div>
  </template>

  <script>
  import { mapGetters, mapMutations } from 'vuex';
  import time from '@/utils/player/time';
  import { mapActions } from 'vuex/dist/vuex.common.js';
  import EventArrows from './analysis_components/EventArrows.vue';

  export default {
    name: 'RunTimingAnalysis',
    mixins: [time],
    components: {
      EventArrows
    },
    created() {
      this.$nextTick(() => {
        this.SET_EVENTS_FILTER_FUNCTION((e) => {
          return e.measure_time
        })

        this.SET_SHOW_MEASURE_TAPE(['msu', 'nsu'].includes(this.pesis_league_name))
        this.setEmpty()
      })
    },
    shortcuts: {
      t: function() {
        this.event_data.run.maximal_run = !this.event_data.run.maximal_run
      },
      keydown: function(e) {
        if(!this.event_data?.run || this.event_data.run.run_id) return
        if(e.metaKey) return

        const keyCode = e.keyCode || e.which
        const key = e.key?.toLowerCase()
        const numberIndex = keyCode - 49

        if(key === 'z' || key === 'x') {
          const direction = key === 'z' ? -1 : 1
          const amount = e.ctrlKey ? 1 : e.shiftKey ? 0.1 : 0.02
          this.jumpPlayerTime(direction * amount)
          e.preventDefault()
          return
        }

        if(numberIndex >= 0 && numberIndex < Object.keys(this.mapped_btns).length && !e.shiftKey && !e.altKey && !e.ctrlKey) {
          this.handleBtnClick(Object.keys(this.mapped_btns)[numberIndex])
          e.preventDefault()
        }
      },
    },
    data: () => ({
      deleting_time: false,
      selected_run_time_key: null,
      event_data: null,
      original_run_snapshot: null,
      empty_data: {
        run: {
          has_run_time: false,
          run_id: null, // luodaan backendissä
          maximal_run: false,
          runner_distance_from_base: null, // etäisyys pesästä metreinä
          run_first_data_point_video_time: null,
          measured_from_hit: false,
          run_video_times: {
            pitch: null,
            bat_drops: null,
            hit: null,
            start: null,
            on_base: null
          },
          run_times: {
            lahto_mailasta: null,
            lahto_syotosta: null,
            lahto_lyonnista: null,
            juoksu: null, // etenijän lähdöstä pesään saapumiseen
          },
          total_run_time: null, // syötön nousemisesta pesään saapumiseen
        }
      },
      mapped_btns: {
        pitch: 'Syöttö irtoaa',
        // bat_drops: 'Maila laskee',
        // hit: 'Lyönti osuu mailaan',
        start: 'Etenijä lähtee',
        on_base: 'Etenijä pesässä'
      },
      hide_btn_states: {
        pitch: ['0'],
        bat_drops: ['1', '1-2', '2', '0'],
        hit: [],
        // hit: ['1', '1-2', '1-3', '2', '2-3', 'Ajo', '0-3'],
        start: ['0'],
        on_base: []
      }
    }),
    computed: {
      ...mapGetters({
        events: 'analysis/events',
        points: 'analysis/points',
        current_event: 'analysis/current_event',
        currentTime: 'player/currentTime',
        accurateCurrentTime: 'player/accurateCurrentTime',
      }),
      ...mapGetters('videos', ['pesis_league_name' ]),
      mark_type_mapped() {
        return {
          "lento": "Lento / nopea",
          "vp": "Väärä pois",
          "takamaila": "Takamaila",
          "kulmamaila": "Kulmamaila",
          "epaselva_maila": "Epäselvä maila",
          "viivastetty": "Viivästetty",
          "oma_lahto": "Oma lähtö",
          "epaselva": "Epäselvä",
        }
      },
      selectedRunTimeLabel() {
        if(!this.selected_run_time_key) return '-'
        const time = this.event_data?.run?.run_video_times?.[this.selected_run_time_key]
        const label = this.mapped_btns[this.selected_run_time_key]
        if(!time) return `${label} (-)`
        return `${label} ${time.toFixed(3)}s`
      },
      hasRunChanges() {
        if(!this.event_data?.run || !this.original_run_snapshot) return false
        return JSON.stringify(this.event_data.run) !== this.original_run_snapshot
      },
      saveDisabled() {
        return !!this.event_data?.run?.run_id && !this.hasRunChanges
      }
    },
    methods: {
      ...mapActions({
        'seek': 'player/seek',
        'openNextEvent': 'analysis/openNextEvent',
        'openPreviousEvent': 'analysis/openPreviousEvent',
        'deleteTimeAdmin': 'videos/deleteTimeAdmin'
      }),
      ...mapMutations('analysis', [
        'SET_EVENT_SILENT'
      ]),
      deleteTime(id) {
        this.deleting_time = true
        this.deleteTimeAdmin(id)
          .then((e) => {
            this.setEmpty(e.data)
            this.SET_EVENT_SILENT(e.data)
          })
          .finally(() => {
            this.deleting_time = false
          })
      },
      handleDistance(d) {
        if(!d) return
        const distances = d.distances

        if(['1-2', '0-2'].includes(this.current_event.bases_state)) {
          const dist = distances.find(d => d.name === "second_base_tip")
          this.event_data.run.runner_distance_from_base = dist ? this.roundDistanceToTenCentimeters(dist.distance) : null
        } else if(['1'].includes(this.current_event.bases_state)) {
          const dist = distances.find(d => d.name === "first_base_tip")
          this.event_data.run.runner_distance_from_base = dist ? this.roundDistanceToTenCentimeters(dist.distance) : null
        }
      },
      roundDistanceToTenCentimeters(distance) {
        return Number((Math.round(Number(distance) * 10) / 10).toFixed(1))
      },
      adjustRunnerDistance(amount) {
        const current = this.event_data.run.runner_distance_from_base || 0
        this.event_data.run.runner_distance_from_base = Math.max(0, this.roundDistanceToTenCentimeters(current + amount))
      },
      handleBtnClick(btn) {
        const time = this.accurateCurrentTime
        const val = this.event_data.run.run_video_times[btn]
        this.event_data.run.run_video_times[btn] = val ? null : time
        this.selected_run_time_key = val ? null : btn
        this.updateRunTiming(time)
      },
      nudgeSelectedRunTime(amount) {
        const key = this.selected_run_time_key
        if(!key || !this.event_data?.run?.run_video_times?.[key]) return

        const current = this.event_data.run.run_video_times[key]
        this.event_data.run.run_video_times[key] = Math.max(0, Number((current + amount).toFixed(3)))
        this.updateRunTiming()
      },
      jumpPlayerTime(amount) {
        const time = this.accurateCurrentTime || this.currentTime || 0
        this.seek(Math.max(time + amount, 0))
      },
      updateRunTiming(firstDataPointTime) {
        if(Object.values(this.event_data.run.run_video_times).every(item => item === null)) {
          this.event_data.run.total_run_time = null
          this.event_data.run.run_first_data_point_video_time = null
          this.event_data.run.has_run_time = false
          this.selected_run_time_key = null
          this.event_data.run.run_times = { lahto: null, juoksu: null }
          return
        }

        const times = Object.values(this.event_data.run.run_video_times)
        const max_time = Math.max(...times.filter(item => item !== null))
        const min_time = Math.min(...times.filter(item => item !== null))

        if(!this.event_data.run.run_first_data_point_video_time) {
          this.event_data.run.run_first_data_point_video_time = firstDataPointTime || min_time
        }

        this.event_data.run.total_run_time = max_time && min_time ? Number((max_time - min_time).toFixed(2)) : null
        this.event_data.run.has_run_time = true

        this.event_data.run.measured_from_hit = this.event_data.run.run_video_times['hit'] && !this.event_data.run.run_video_times['pitch']

        let d = this.event_data.run.run_video_times
        this.event_data.run.run_times = { lahto: null, juoksu: null }
        if(d.pitch && d.start) {
          this.event_data.run.run_times.lahto = d.start - d.pitch
        }
      },
      setEmpty(newVal) {
        let ne = JSON.parse(JSON.stringify(newVal ? newVal : this.current_event))

        if(ne.phase_done > 2 && ne.run) {
          this.event_data = JSON.parse(JSON.stringify(ne))
        } else {
          this.event_data = JSON.parse(JSON.stringify(this.empty_data))
        }
        this.original_run_snapshot = this.event_data?.run
          ? JSON.stringify(this.event_data.run)
          : null
        this.selected_run_time_key = this.firstRunTimeKeyWithValue()
      },
      firstRunTimeKeyWithValue() {
        if(!this.event_data?.run?.run_video_times) return null
        return Object.keys(this.mapped_btns).find(key => this.event_data.run.run_video_times[key]) || null
      },
      save() {
        const new_event = {
          ...this.current_event,
          ...this.event_data,
          phase_done: Math.max(this.current_event.phase_done, 3)
        }

        this.$emit('eventSaved', new_event)
      },
      ...mapMutations({
        'SET_EVENTS_FILTER_FUNCTION': 'analysis/SET_EVENTS_FILTER_FUNCTION',
        'SET_SHOW_MEASURE_TAPE': 'analysis/SET_SHOW_MEASURE_TAPE',
      })
    },
    beforeDestroy() {
      this.SET_SHOW_MEASURE_TAPE(false)
      this.SET_EVENTS_FILTER_FUNCTION(null)
    },
    watch: {
      'points': {
        handler(newVal) {
          this.handleDistance( newVal[ newVal.length - 1 ])
        },
        deep: true
      },
      current_event: {
        handler(newVal) {
          this.setEmpty(newVal)
        },
        immediate: true
      }
    }
  }
  </script>